import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import LogoCz from '../../img/Cribis.cz_grey';
import LogoSk from '../../img/Cribis.sk_grey';
import LogoCzWhite from '../../img/Cribis.cz_white';
import LogoSkWhite from '../../img/Cribis.sk_white';
import BirdGrey from '../../img/icons/leftPanel/Bird_grey';
import BirdWhite from '../../img/icons/leftPanel/Bird_white';
import RepiCz from '../../img/repi/RepiCz';
import RepiSk from '../../img/repi/RepiSk';

import './menuLogoLink.scss'

class MenuLogoLink extends React.Component {
    render() {
        const path = this.props.repi === true ? "/repi/search" : "/search";

        return ( 
            <div className={classnames("logo", { "repi-logo-nav": this.props.repi === true, "repi-logo-colorized": this.props.repi === true })}>
                <Link to={{ pathname: `${this.props.user.authentication.isAuthorized ? path : "/"}`, state: { reset: true } }}
                        className="cribis-icon">
                    {this.getImage()}
                </Link>
            </div>
        );
    }

    getImage() {
        const tinted = localStorage.locales_theme === 'dark' || this.props.tinted;

        if (this.props.repi === true) {
            return this.props.user.authentication.profile.agentLanguage === "sk-SK"
                ? <RepiSk className="svg-standard-fill" /> : <RepiCz className="svg-standard-fill" />;
        }

        if (!this.props.fixed)
            return tinted ? <BirdWhite className="svg-standard-fill" /> : <BirdGrey className="svg-standard-fill" />;

        return this.props.user.authentication.profile.agentLanguage === "sk-SK"
            ? tinted ? <LogoSkWhite className="svg-standard-fill" /> : <LogoSk className="svg-standard-fill" />
            : tinted ? <LogoCzWhite className="svg-standard-fill" /> : <LogoCz className="svg-standard-fill" />;
    }
}

export default connect(
    state => { return {user: state.userContext } }
)(MenuLogoLink);